import { createElement, forwardRef } from "react";
import { kebabCase } from "utilities/strings";

interface IconProps {
  color?: string;
  size?: number | string;
  stroke?: number | string;
  children?: React.ReactNode;
  ref?: React.Ref<SVGSVGElement>;
}

export default function createIcon(
  name: string,
  nodes: ReadonlyArray<readonly [string, Record<string, unknown>]>,
  fill?: string
) {
  const Component = forwardRef<SVGSVGElement, IconProps>(
    ({ color = "currentColor", size = 24, stroke = 1, children, ...rest }, ref) =>
      createElement(
        "svg",
        {
          ref,
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          viewBox: "0 0 24 24",
          fill: fill ? color : "none",
          stroke: fill ? "none" : color,
          strokeWidth: fill ? "none" : stroke,
          className: `cd-icon cd-icon-${kebabCase(name)}`,
          ...rest,
        },
        [
          ...nodes.map(([tag, attrs], index) =>
            // eslint-disable-next-line react/no-array-index-key
            createElement(tag, { key: `${name}-${index}`, ...attrs })
          ),
          ...(children ? [children] : []),
        ]
      )
  );

  Component.displayName = `Icon${name}`;

  return Component;
}
